/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ArrowSolidDownFillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path d="M12.7909 17.3938C12.3541 17.8305 11.6459 17.8305 11.2091 17.3938L2.24737 8.432C1.71893 7.90356 2.0932 7 2.84053 7L21.1595 7C21.9068 7 22.2811 7.90356 21.7526 8.432L12.7909 17.3938Z" />
      </svg>
    </Icon>
  );
});

export { ArrowSolidDownFillIcon };
